import { render, staticRenderFns } from "./NoMortgageAlternativesPage.vue?vue&type=template&id=2e5ed8e2&scoped=true"
import script from "./NoMortgageAlternativesPage.vue?vue&type=script&lang=js"
export * from "./NoMortgageAlternativesPage.vue?vue&type=script&lang=js"
import style0 from "./NoMortgageAlternativesPage.vue?vue&type=style&index=0&id=2e5ed8e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5ed8e2",
  null
  
)

export default component.exports